import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import ErrorComponent from "../../Components/ErrorComponent";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import { CloseOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import PreferredDoctor from "./PreferredDoctors";
import React, { useEffect } from "react";

function AllPreferredDoctor() {
  const {
    getPreferredDoctors,
    prefDocsLoadState,
    setPreviewScreen,
    preferredDoctors,
    navigate,
  } = useConsultDoctorContext();

  useEffect(() => {
    getPreferredDoctors("");
  }, []);

  useEffect(() => {
    if (preferredDoctors.length <= 0) {
      navigate(-1);
    }
  }, [preferredDoctors]);

  const handleClose = () => {
    setPreviewScreen("");
  };

  let content = null;

  if (prefDocsLoadState === "load") {
    content = (
      <div className="w-full flex justify-center items-center py-3">
        <CircularProgress />
      </div>
    );
  } else if (["ISE", "retry", "timeout"].includes(prefDocsLoadState)) {
    content = (
      <ErrorComponent
        onRetry={() => getPreferredDoctors("", "retry")}
        isLoading={prefDocsLoadState === "retry"}
      />
    );
  } else {
    content = (
      <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
        <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-81px)] sm:h-full sm:max-h-[500px] rounded">
          <PreferredDoctor doctors={preferredDoctors} />
        </ScrollArea.Viewport>
        <ScrollBar />
      </ScrollArea.Root>
    );
  }

  return (
    <React.Fragment>
      <div className="w-full border-b">
        <div className="flex flex-row p-3">
          <CloseOutlined className="invisible" />
          <div className="text-center text-md font-bold flex-1">
            Preferred Doctors
          </div>
          <CloseOutlined className=" cursor-pointer" onClick={handleClose} />
        </div>
      </div>
      <div className="w-full p-4">{content}</div>
    </React.Fragment>
  );
}

export default AllPreferredDoctor;
